import { render, staticRenderFns } from "./menuleft.vue?vue&type=template&id=2bae6731&scoped=true"
import script from "./menuleft.vue?vue&type=script&lang=js"
export * from "./menuleft.vue?vue&type=script&lang=js"
import style0 from "./menuleft.vue?vue&type=style&index=0&id=2bae6731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae6731",
  null
  
)

export default component.exports